<h2 mat-dialog-title>
  {{ step === 1 ? 'Importar Lançamentos de Planilha' : 'Pré-visualização da Importação' }}
</h2>

<button mat-icon-button type="button" class="dialog-close-button" aria-label="Fechar" (click)="dialogRef.close()">
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  <!-- ── Step 1: Upload ──────────────────────────────────────── -->
  @if (step === 1) {
  <div class="info-alert">
    <mat-icon class="material-symbols-outlined">info</mat-icon>
    <span>A importação apenas insere lançamentos novos. Não atualiza lançamentos já existentes.</span>
  </div>
  <p class="hint-text">O arquivo deve estar no formato <strong>.csv</strong> com o seguinte layout:</p>
  <button mat-button (click)="downloadModelo()">
    <mat-icon class="material-symbols-outlined">download</mat-icon>
    download da planilha de exemplo
  </button>
  <div class="layout-table">
    <table>
      <thead>
        <tr>
          @for (col of colunas; track col) {
          <th>{{ col }}</th>
          }
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>25/03/2026</td>
          <td>Categoria</td>
          <td>Descrição</td>
          <td>Entrada</td>
          <td>1500,00</td>
          <td>TAG1, TAG2</td>
          <td>Caixa</td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- Upload zone -->
  <div class="upload-zone" [class.drag-over]="isDragOver" (dragover)="onDragOver($event)"
    (dragleave)="isDragOver = false" (drop)="onDrop($event)" (click)="fileInput.click()">
    <input #fileInput type="file" accept=".csv" style="display: none" (change)="onFileSelected($event)" />
    @if (!selectedFile && !isLoading) {
    <mat-icon class="upload-icon material-symbols-outlined">upload_file</mat-icon>
    <p>Arraste o arquivo aqui ou <strong>clique para selecionar</strong></p>
    <small>Formato aceito: .csv</small>
    }
    @if (selectedFile && !isLoading) {
    <mat-icon class="upload-icon" style="color: #2e7d32">check_circle</mat-icon>
    <p>
      <strong>{{ selectedFile.name }}</strong>
    </p>
    <small>{{ (selectedFile.size / 1024).toFixed(1) }} KB</small>
    <button mat-button type="button" (click)="removerArquivo($event)">Remover</button>
    }
    @if (isLoading) {
    <mat-spinner [diameter]="36"></mat-spinner>
    <p>Validando arquivo...</p>
    }
  </div>
  }

  <!-- ── Step 2: Preview ────────────────────────────────────── -->
  @if (step === 2) {
  <div class="filter-bar">
    <div class="metric-item" [class.active-metric]="currentFilter === 'todos'" (click)="aplicarFiltro('todos')">
      <span class="metric-label">todos</span>
      <strong class="metric-value">{{ getTotal() }}</strong>
    </div>
    <div class="metric-item" [class.active-metric]="currentFilter === 'novos'" (click)="aplicarFiltro('novos')">
      <span class="metric-label"><span class="dot dot-green"></span> válidos</span>
      <span class="metric-value-sm">{{ getNovos() }}</span>
    </div>
    <div class="metric-item" [class.active-metric]="currentFilter === 'avisos'" (click)="aplicarFiltro('avisos')">
      <span class="metric-label"><span class="dot dot-yellow"></span> advertências</span>
      <span class="metric-value-sm">{{ getAvisos() }}</span>
    </div>
    <div class="metric-item" [class.active-metric]="currentFilter === 'erros'" (click)="aplicarFiltro('erros')">
      <span class="metric-label"><span class="dot dot-red"></span> erros</span>
      <span class="metric-value-sm">{{ getErros() }}</span>
    </div>
  </div>
  <div class="preview-table-container">
    <table mat-table [dataSource]="itemsFiltered">
      <ng-container matColumnDef="status" sticky>
        <th mat-header-cell *matHeaderCellDef class="col-status"></th>
        <td mat-cell *matCellDef="let item" class="col-status" [matTooltip]="getTooltip(item)"
          matTooltipClass="multiline-tooltip" matTooltipPosition="above">
          @if (item.isValido && !item.isAlerta) {
          <span class="dot dot-green"></span>
          }
          @if (item.isValido && item.isAlerta) {
          <span class="dot dot-yellow"></span>
          }
          @if (!item.isValido) {
          <span class="dot dot-red"></span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="data">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let item" [matTooltip]="getTooltip(item)" matTooltipClass="multiline-tooltip"
          matTooltipPosition="above">
          {{ item.dadosOriginais.data }}
        </td>
      </ng-container>
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let item" [matTooltip]="getTooltip(item)" matTooltipClass="multiline-tooltip"
          matTooltipPosition="above">
          {{ item.dadosOriginais.tipo }}
        </td>
      </ng-container>
      <ng-container matColumnDef="valor">
        <th mat-header-cell *matHeaderCellDef>Valor</th>
        <td mat-cell *matCellDef="let item" [matTooltip]="getTooltip(item)" matTooltipClass="multiline-tooltip"
          matTooltipPosition="above">
          {{ item.dadosOriginais.valor }}
        </td>
      </ng-container>
      <ng-container matColumnDef="conta">
        <th mat-header-cell *matHeaderCellDef>Conta</th>
        <td mat-cell *matCellDef="let item" [matTooltip]="getTooltip(item)" matTooltipClass="multiline-tooltip"
          matTooltipPosition="above">
          {{ item.dadosOriginais.conta }}
        </td>
      </ng-container>
      <ng-container matColumnDef="categoria">
        <th mat-header-cell *matHeaderCellDef>Categoria</th>
        <td mat-cell *matCellDef="let item" [matTooltip]="getTooltip(item)" matTooltipClass="multiline-tooltip"
          matTooltipPosition="above">
          {{ item.dadosOriginais.categoria }}
        </td>
      </ng-container>
      <ng-container matColumnDef="historico">
        <th mat-header-cell *matHeaderCellDef>Histórico</th>
        <td mat-cell *matCellDef="let item" [matTooltip]="getTooltip(item)" matTooltipClass="multiline-tooltip"
          matTooltipPosition="above">
          {{ item.dadosOriginais.historico }}
        </td>
      </ng-container>
      <ng-container matColumnDef="tags">
        <th mat-header-cell *matHeaderCellDef>Tags</th>
        <td mat-cell *matCellDef="let item" [matTooltip]="getTooltip(item)" matTooltipClass="multiline-tooltip"
          matTooltipPosition="above">
          {{ item.dadosOriginais.tags }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="getRowClass(row)"></tr>
    </table>
    @if (itemsFiltered.length === 0) {
    <div class="empty-state">Nenhum item neste filtro.</div>
    }
  </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (step === 1) {
  <button mat-stroked-button class="btn-secondary" mat-dialog-close>Cancelar</button>
  }

  @if (step === 2) {
  <button mat-button (click)="voltarParaUpload()">
    <mat-icon>refresh</mat-icon> Escolher outro arquivo
  </button>
  <div [matTooltip]="getButtonTooltip()" [matTooltipDisabled]="!isImportDisabled">
    <button mat-flat-button class="btn-primary" [disabled]="isImportDisabled || isLoading"
      (click)="confirmarImportacao()">
      @if (isLoading) {
      <mat-spinner [diameter]="18"></mat-spinner>
      }
      @if (!isLoading) {
      <mat-icon>check</mat-icon>
      }
      {{ isLoading ? 'Importando...' : 'Confirmar Importação' }}
    </button>
  </div>
  }
</mat-dialog-actions>